<template>
    <v-tooltip bottom :disabled="!tooltip">
        <template v-slot:activator="{ on, attrs }">
            <span
                v-bind="attrs"
                v-on="on"
                class="disabled-tooltip-activator d-inline-flex"
                :class="wrapperClass"
            >
                <slot />
            </span>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "DisabledTooltipActivator",
    props: {
        tooltip: {
            type: String,
            default: null,
        },
        wrapperClass: {
            type: String,
            default: null,
        },
    },
};
</script>
